/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Kiotviet_Unlinked_Filter_LabelInputs */

const vi_order_kiotviet_unlinked_filter_label = /** @type {(inputs: Order_Kiotviet_Unlinked_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nối sản phẩm KiotViet`)
};

/**

* @param {Order_Kiotviet_Unlinked_Filter_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_kiotviet_unlinked_filter_label = /** @type {((inputs?: Order_Kiotviet_Unlinked_Filter_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Kiotviet_Unlinked_Filter_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_kiotviet_unlinked_filter_label(inputs)
});